import { render } from "./Intro.vue?vue&type=template&id=41486772&scoped=true&ts=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"

import "@/components/Intro/style.scss?vue&type=style&index=0&id=41486772&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41486772"]])

export default __exports__